import React, { useState, useMemo } from "react";
import { RemixBuilderContext } from "../remix/shared/RemixBuilderContext";

export const VariantTemplatePreviewModalProvider = (props) => {
  const {
    templateData,
    website,
    subscription,
    account,
    current_user,
    remix_mappings,
    styles = {},
  } = props;

  const initialContext = {
    current_user,
    website,
    subscription,
    account,
    currentMonthYear: moment().format("MMMM YYYY"),
    environment: props.environment ?? (typeof window !== "undefined" ? window.environment : undefined),
    filestack_api_key: props.FILESTACK_API_KEY,
    uploaded_sections: [],
    matched_sections: templateData
      ? [
          {
            id: crypto.randomUUID(),
            position: 1,
            selected: true,
            template: templateData.template,
            tags: [],
          },
        ]
      : [],
    section_templates: [],
    current_step: 1,
    from_scratch: true,
    remix_settings: {
      variant_name: "",
      styles: { ...styles },
      options: {
        remix_all_text: false,
        remix_tone: "",
        remix_asset_urls: [],
        excluded_element_types: [],
      },
    },
    settings: {
      max_section_remixes: 50,
      used_section_remixes: 0,
    },
    remix_mappings: remix_mappings || {},
    remix_loading: null,
  };

  const [contextData, setContextData] = useState(initialContext);

  const builder = useMemo(
    () => ({
      goToStep: (step) => {
        setContextData((prev) => ({ ...prev, current_step: step }));
      },

      goToPreviousStep: () => {
        setContextData((prev) => ({
          ...prev,
          current_step: Math.max(1, prev.current_step - 1),
        }));
      },

      goToNextStep: () => {
        setContextData((prev) => ({
          ...prev,
          current_step: Math.min(2, prev.current_step + 1),
        }));
      },

      updateRemixSettings: (key, value) => {
        setContextData((prev) => ({
          ...prev,
          remix_settings: {
            ...prev.remix_settings,
            [key]: value,
          },
        }));
      },

      setRemixLoading: (loadingState) => {
        setContextData((prev) => ({
          ...prev,
          remix_loading: loadingState,
        }));
      },
    }),
    []
  );

  return (
    <RemixBuilderContext.Provider
      value={[contextData, builder, setContextData]}
    >
      {props.children}
    </RemixBuilderContext.Provider>
  );
};
